import { Component } from "@angular/core";

@Component({
    selector:'app-rs-contact',
    templateUrl:'./rs-contact.component.html',
    styleUrls:['./rs-contact.component.scss'],
    standalone: false
})
export class RSContactComponent{
    email:string ='RA-PWODPPBC@pa.gov'
}